var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading-page"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"loading-spinner"},[_c('img',{staticClass:"loading-img",attrs:{"src":"https://lbs-nfncb.nfncb.cn/gzmap/img/loading.png","alt":""}})]),_c('div',{staticClass:"loading-text"},[_vm._v("加载中...")])])
}]

export { render, staticRenderFns }